import { ParticipantType } from '@core/types';
import { User } from '@core/ui';
import { ParticipantItem } from '../../../types';

export const ParticipantRow = ({ participant, onParticipantClick }: { participant: ParticipantItem; onParticipantClick: (participantId: string) => void }) => {
    const onClick = () => {
        onParticipantClick(participant.participantId);
    };

    return (
        <button
            onClick={onClick}
            className="relative w-full hover:bg-accent-light focus-visible:bg-accent-light rounded-lg cursor-pointer flex items-center mt-2 mb-1 px-2 py-1 select-none transition-colors ease-in-out duration-200"
        >
            <div className="w-10 h-10 flex-none rounded-lg bg-main-gradient mr-2 p-1">
                <User classNames="size-8 stroke-white" />
            </div>
            {participant.nickname}
            {!participant.nickname && participant.participantType === ParticipantType.anonymous && 'Anonymous'}
            {!participant.nickname && participant.participantType === ParticipantType.invited && 'Invited'}
            {participant.noOfUnreadMessages > 0 && (
                <span className="absolute left-8 -top-1 min-w-5.5 bg-warning rounded-full text-white text-sm text-center leading-none p-1">
                    {participant.noOfUnreadMessages}
                </span>
            )}
        </button>
    );
};
